import React, {Component} from 'react'
import Header from './header'
import ToastContainer from "../toasts/toast-container"
import store from "store"
import * as Sentry from '@sentry/browser'
import { MUSProvider } from "@mus/core"
import { ThemeProvider, createTheme } from '@mui/material/styles'

const muiTheme = createTheme()

import {
    checkToken,
    makeAuth,
} from 'app/helpers/session'

import {
    setActiveRoute,
    setQueriesToStore,
} from "actions"

import { setAlternativeTemplatesLevelsToStore, setAlternativeTemplatesToStore, setTemplatesToStore } from "template-edit/reducers"
import { setProjectToStore } from "../reducers/project"

import {
    getTemplates,
    projectId,
    getProject,
    applyAllSuggestedElementChanges,
    applySelectedElementChanges,
    getQueries,
    getAlternativeTemplates,
    getAlternativeTemplatesLevels,
    getFontsUsedInProject,
} from "app/helpers/api"

import ModalNewsBox from "./modal-news-box"
import FirstStepsModal from "first-steps";
import Websocketeer from "./websocketeer";
import AppRoutes from "./routes";
import {AxiosResponse} from "axios";
import { AlternativeTemplate, AlternativeTemplatesLevels, Project, Query, Template } from 'app/types/model-types'

import CheckElementsModal from './check-elements-modal'
import ModalPopUpBox from './modal-popup-box'
import { tags } from '../../shape-edit/components/sets';
import { Theme } from '@bdfx/mergado-ui-kit'

interface Props {
}

interface State {
    showNewsBox: number
    showPopUpBox: number
    showFirstSteps: number
    checkElements: boolean
}

export const routes = {
    HOME: "HOME",
    SETTINGS: "SETTINGS",
    PRODUCTS: "PRODUCTS",
    WIDGET: "WIDGET",
    SHOWROOM: "SHOWROOM",
}

class App extends Component<Props, State> {
    constructor(props) {
        super(props)
        this.state = {
            showNewsBox: null,
            showPopUpBox: null,
            showFirstSteps: null,
            checkElements: true,
        }
        Sentry.addIntegration(
            Sentry.replayIntegration({
                maskAllInputs: false,
                maskAllText: false,
                blockAllMedia: false,
                minReplayDuration: 10000,
            })
        );
    }

    alertPing = (e) => {
        console.log(e)
        /*store.dispatch(createToast(textToast('success', 'PONG')))*/
    }

    hideCheckElements = () => {
        this.setState({ checkElements: false })
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Sentry.withScope((scope) => {
            scope.setExtras({ errorInfo })
            Sentry.captureException(error)
        });
    }

    componentDidMount() {
        if (!checkToken(projectId)) {
            return makeAuth(projectId, location.pathname)
        }

        getTemplates()
            .then((response: AxiosResponse<Template[]>) => {
                store.dispatch(setTemplatesToStore(response.data))
                store.dispatch(setActiveRoute(routes.HOME))
            })
            .catch(e => {
                console.error('get templates error', e)
            })

        getProject()
            .then((response: AxiosResponse<Project>) => {
                store.dispatch(setProjectToStore(response.data))
                this.setState({
                    showNewsBox: response.data.show_newsbox,
                    showPopUpBox: response.data.show_popup,
                    showFirstSteps: response.data.show_first_steps,
                })

            })
            .catch(e => console.error('get projects error', e))

        getQueries()
            .then((response: AxiosResponse<Query[]>) => {
                store.dispatch(setQueriesToStore(response.data))
            })
            .catch(error => {
                console.error('error while getting queries', error)
            })

        getAlternativeTemplates()
            .then((response: AxiosResponse<AlternativeTemplate[]>) => {
                store.dispatch(setAlternativeTemplatesToStore(response.data))
            })
            .catch(e => {
                console.error('get alternative templates error', e)
            })

        getAlternativeTemplatesLevels()
            .then((response: AxiosResponse<AlternativeTemplatesLevels[]>) => {
                store.dispatch(setAlternativeTemplatesLevelsToStore(response.data))
            })
            .catch(e => {
                console.error('get alternative templates error', e)
            })
    }

    render() {
        const { showNewsBox, showPopUpBox, showFirstSteps, checkElements } = this.state

        const websockets: Websocketeer['props']['listeners'] = [
            { name: '.app.ping', callback: this.alertPing },
            /*{name: '.app.ping', callback: this.alertPing, general: true},*/
        ]

        return (
            <ThemeProvider theme={muiTheme}>
            <MUSProvider customTheme={{ 'typographyFontFamily': 'Roboto, sans-serif', 'colorPrimary': Theme.blue, 'colorSecondary': '#FFFF' }}>
            <div>
                <ToastContainer />
                <Header />
                <section>
                    <AppRoutes />

                    {/* {!!showPopUpBox &&
                        <ModalPopUpBox key="modalpopupbox" showPopUpBox={showPopUpBox} />
                    } */}

                    {!!showNewsBox &&
                        <ModalNewsBox key="modalnewsbox" showNewsBox={showNewsBox} />
                    }

                    {!!showFirstSteps &&
                        <FirstStepsModal key="modalfirststeps" showFirstSteps={showFirstSteps} />
                    }

                    {checkElements &&
                        <CheckElementsModal hideCheckElements={this.hideCheckElements} />
                    }
                </section>

                {websockets && <Websocketeer listeners={websockets} />}
                </div>
                </MUSProvider>
            </ThemeProvider>
        )
    }
}

export default App